module.exports = __webpack_public_path__ + "static/roboto-light-b116fcc75f4383a95be883a442e72ede.woff2";